import { PortalUrls } from '@servicetitan/cp-ui';

type Keys = 'list' | 'item';

export const ServiceAgreementMapUrls: Record<Keys, string> = {
    list: PortalUrls.serviceAgreements.root,
    item: PortalUrls.serviceAgreements.root + PortalUrls.serviceAgreements.item,
};
